import React, {useContext, useEffect, useState} from 'react';
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {auth, db} from "../utils/firebaseApp";
import 'react-simple-keyboard/build/css/index.css';
import CustomNumericKeyboard from "./on-screen-keyboard/CustomNumericKeyboard";
import {toast} from "react-toastify";
import {collection, doc, getDocs, query, setDoc, updateDoc, where} from "firebase/firestore";
import {Header} from "../shared-components/Header";
import {AppContext} from "../utils/AppContext";
import {QrReaderC} from "./qr-code-scanner/QrCodeReaderComponentHtml5Only";
import chargeBackground from "../assets/charge.svg";

const AddCash = () => {
        const [qrCodeResult, setQrCodeResult] = useState(null);
        const [canAccess, setCabAccess] = useState(false);
        const [isScanning, setIsScanning] = useState(true);
        const [cashToAdd, setCashToAdd] = useState(0);
        const [paymentCard, setPaymentCard] = useState(null);
        const [desiredScannerState, setDesiredScannerState] = useState(null);
        const {state: {currentUser}, dispatch} = useContext(AppContext);

        useEffect(() => {
            console.log('wallets page')
            if (!qrCodeResult) return
            if (!currentUser) return
            const cardQuery = query(
                collection(db, "paymentCards"),
                where("eventUid", "==", currentUser.event),
                where("uid", "==", qrCodeResult)
            );
            getDocs(cardQuery).then((querySnapshot) => {
                if (querySnapshot.empty) {
                    setCabAccess(false)
                    toast.error('Nemate pristup ovom događaju!');
                    const timeoutId = setTimeout(() => {
                        setQrCodeResult(null);
                    }, 5000);

                    // Clear timeout if the component is unmounted or qrCodeResult changes
                    return () => clearTimeout(timeoutId);
                }
                querySnapshot.forEach((doc) => {
                    if (doc.id === qrCodeResult) {
                        setCabAccess(true)
                        setPaymentCard(doc.data())
                    }
                });
            });
        }, [qrCodeResult])

        const onChange = (input) => {
            setCashToAdd(input);
        }

        const addCashToUser = () => {
            const txnTime = Date.now()
            if (paymentCard) {
                updateDoc(doc(db, "paymentCards", qrCodeResult), {
                    lastChangeByUid: auth.currentUser.uid,
                    lastTransactionTime: txnTime,
                    balance: typeof cashToAdd === 'string' ? parseInt(cashToAdd) + parseInt(paymentCard.balance) : cashToAdd + parseInt(paymentCard.balance),
                }).then(r => {
                    toast.success(`Added 🪙${cashToAdd} to user: ${qrCodeResult}`)
                    setCashToAdd(0)
                    setQrCodeResult(null)
                }).catch(e => {
                    console.log(e)
                    toast.error('Adding failed, please try again')
                })

                setDoc(doc(db, "bankerTransactions", crypto.randomUUID()), {
                    addedBy: auth.currentUser.uid,
                    addedByEmail: auth.currentUser.email,
                    lastTransactionTime: txnTime,
                    amountAdded: typeof cashToAdd === 'string' ? parseInt(cashToAdd) : cashToAdd,
                    addedTo: qrCodeResult,
                    eventUid: currentUser.event

                }).then(r => {
                    setQrCodeResult(null)
                    setCashToAdd(0)
                    setPaymentCard(null)
                    // toast.success(`TXN ADDED: ${cashToAdd} to user ${qrCodeResult}`)
                }).catch(e => {
                    console.log(e)
                    toast.error('Adding failed, please try again')
                })
            } else {
                setDoc(doc(db, "paymentCards", qrCodeResult), {
                    lastAddByuid: auth.currentUser.uid,
                    lastTransaction: txnTime,
                    balance: typeof cashToAdd === 'string' ? parseInt(cashToAdd) : cashToAdd,
                }).then(r => {
                    toast.success(`Added 🪙${cashToAdd} to user: ${qrCodeResult}`)
                }).catch(e => {
                    console.log(e)
                    toast.error('Adding failed, please try again')
                })

                setDoc(doc(db, "transactions", crypto.randomUUID()), {
                    addedBy: auth.currentUser.uid,
                    addedByEmail: auth.currentUser.email,
                    lastTransactionTime: txnTime,
                    amountAdded: parseInt(cashToAdd),
                    addedTo: qrCodeResult
                }).then(r => {
                    setCashToAdd(0)
                    setQrCodeResult(null)
                    setPaymentCard(null)
                    // toast.success(`TXN ADDED: ${cashToAdd} to user ${qrCodeResult}`)
                }).catch(e => {
                    console.log(e)
                    toast.error('Adding failed, please try again')
                })
            }
        }

        return (
            <>
                <Header/>
                <Stack direction={'column'} alignItems={'center'}
                       sx={{
                           minHeight: '100vh', backgroundImage: `url(${chargeBackground})`,
                           backgroundSize: 'cover'
                       }}>
                    <Typography variant={'h1'} sx={{color: 'white', margin: 5}}><strong>Dodaj Tokene</strong></Typography>

                    {!qrCodeResult &&
                        <QrReaderC
                            setQrCodeResult={setQrCodeResult}
                        />}

                    {qrCodeResult &&
                        <Stack justifyContent={'center'}>
                            <Typography variant={'h1'}
                                        sx={{
                                            color: 'white',
                                            margin: 5,
                                            textAlign: 'center',
                                        }}
                            >
                                <strong>🪙 {cashToAdd}</strong>
                            </Typography>
                            <CustomNumericKeyboard onChange={onChange}/>
                            <Button
                                onClick={() => addCashToUser()}
                                disabled={!canAccess}
                                variant={'contained'} size={'large'}
                                sx={{backgroundColor: 'white', color: 'black', margin: 2, fontSize: 20}}>
                                <strong>Add cash</strong>
                            </Button>
                        </Stack>
                    }
                </Stack>
            </>
        )
    }
;

export default AddCash;
